import React, { useEffect, useState } from "react";
import { GitBranch } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Lot 634 — suggestion d'église : le responsable d'au moins une église vérifiée peut déclarer « cette église est une annexe de… ».
// Caché quand le membre ne dirige aucune église mère (une annexe ne peut pas avoir d'annexes).
export const AnnexPicker = ({ value, onChange, testPrefix, tr }) => {
  const { user } = useApp();
  const [mine, setMine] = useState([]);
  useEffect(() => {
    if (!user) return;
    api.get("/churches/mine").then(({ data }) => setMine((data.churches || []).filter((c) => c.owned && !c.parent_church_id))).catch(() => setMine([]));
  }, [user]);
  if (!mine.length) return null;
  const on = !!value.parent_church_id;
  const toggle = (v) => onChange({ ...value, parent_church_id: v ? (value.parent_church_id || mine[0].id) : "" });
  return (
    <div className="rounded-xl border px-3 py-2.5" style={{ borderColor: on ? "#60A5FA" : "var(--yalola-border)", background: on ? "#EFF6FF" : "var(--yalola-surface-alt)" }} data-testid={`${testPrefix}-annex`} data-on={on ? 1 : 0}>
      <label className="flex items-center justify-between gap-3 cursor-pointer">
        <span className="text-sm font-medium flex items-center gap-1.5"><GitBranch size={14} style={{ color: "#1E40AF" }} /> {tr("annex_toggle")}</span>
        <Switch checked={on} onCheckedChange={toggle} data-testid={`${testPrefix}-annex-toggle`} />
      </label>
      {on && (
        <div className="mt-2">
          <Label className="text-xs">{tr("annex_choose")}</Label>
          <Select value={value.parent_church_id} onValueChange={(v) => onChange({ ...value, parent_church_id: v })}>
            <SelectTrigger data-testid={`${testPrefix}-annex-parent`}><SelectValue /></SelectTrigger>
            <SelectContent>
              {mine.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`${testPrefix}-annex-parent-${c.id}`}>{c.name}{c.city ? ` — ${c.city}` : ""}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
      <p className="text-[11px] mt-1.5" style={{ color: "var(--yalola-text-muted)" }}>{tr("annex_hint")}</p>
    </div>
  );
};
